import React from "react";
import "./Projects.css";
import project1 from "./project1.png";
import project2 from "./project2.png";
import project3 from "./project3.png";
import project4 from "./project4.png";
import project7 from "./project7.png";
import bokbok from "./bokbok.png";
import Reactlogo from "../Skills/logo192.png";
import Js from "../Skills/js.png";
import Pg from "../Skills/postgres.png";
import Heroku from "../Skills/heroku.png";
import Node from "../Skills/nodejs.png";
import Bootstrap from "../Skills/bootstrap.png";
import Api from "../Skills/api.png";
import Css from "../Skills/css.png";
import Firebase from "../Skills/firebase.png";
import Vue from "../Skills/vue.png";
//import wp from "../Skills/wordpress.png";

function Projects() {
  return (
    <div className="project-container">
      <section className="projects">
        <a
          href="https://facetracking-app.herokuapp.com/"
          target="_blank "
          rel="noopener noreferrer"
        >
          <img
            className="proimg"
            src={project1}
            loading="lazy"
            alt="project1"
          />
        </a>

        <div className="desc">
          <p>
            A Face Tracking App. This web app can detect face in a picture. This
            is one of my full stack project, utilizes React, Node, Express and
            PostgreSQL as the Database. It is deployed in Heroku. DEMO CREDS:
            email: test245@gmail.com, password: test123
          </p>
          <div>
            <img className="tag" src={Reactlogo} alt="reactlogo" />
            <img className="tag" src={Js} alt="js" />
            <img className="tag" src={Node} alt="Nodejs" />
            <img className="tag" src={Pg} alt="postgreSQL" />
            <img className="tag" src={Heroku} alt="heroku" />
          </div>
          <button className="pro-button">
            <a
              href="https://facetracking-app.herokuapp.com/"
              target="_blank "
              rel="noopener noreferrer"
            >
              Demo
            </a>
          </button>
          <button className="pro-button">
            <a
              href="https://github.com/w3tsa/facetracking-api"
              target="_blank"
              rel="noopener noreferrer"
            >
              Code
            </a>
          </button>
        </div>
      </section>
      <hr />
      <section className="projects">
        <a
          href="https://bokbok.vercel.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="proimg"
            src={bokbok}
            loading="lazy"
            alt="bokbok chat app"
          />
        </a>
        <div className="desc">
          <p>
            This full stack chat app uses firebase as the Database,
            Authentication & Vercel for hosting. For UI I have used REACT js.
          </p>
          <div>
            <img className="tag" src={Reactlogo} alt="Vue" />
            <img className="tag" src={Firebase} alt="Firebase" />
          </div>
          <button className="pro-button">
            <a
              href="https://bokbok.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Demo
            </a>
          </button>
          <button className="pro-button">
            <a
              href="https://github.com/w3tsa/idea-suggest"
              target="_blank"
              rel="noopener noreferrer"
            >
              Code
            </a>
          </button>
        </div>
      </section>
      <hr />

      <section className="projects">
        <a
          href="https://t9jg8.csb.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="proimg"
            src={project7}
            loading="lazy"
            alt="project4"
          />
        </a>
        <div className="desc">
          <p>
            Lights Out is a logic/puzzle game, played on a gird of individual
            lights, which can either be lit or unlit. The puzzle is won when
            when all of the lights are turned off. This React app was made with
            three components - APP, Cell and Board.
          </p>
          <div>
            <img className="tag" src={Reactlogo} alt="ReactApp" />
            <img className="tag" src={Js} alt="js" />
          </div>
          <button className="pro-button">
            <a
              href="https://t9jg8.csb.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Demo
            </a>
          </button>
          <button className="pro-button">
            <a
              href="https://github.com/w3tsa/LightsOut"
              target="_blank"
              rel="noopener noreferrer"
            >
              Code
            </a>
          </button>
        </div>
      </section>
      <hr />
      <section className="projects">
        <a
          href="https://image-search-pagination.netlify.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="proimg"
            src={project3}
            loading="lazy"
            alt="project3"
          />
        </a>
        <div className="desc">
          <p>
            A pure vanilla JavaScript Project using HTML, Skeleton css and an
            external API call with pagination. It has been deployed in Netlify.
          </p>
          <div>
            <img className="tag" src={Js} alt="js" />
            <img className="tag" src={Css} alt="skeleton css" />
            <img className="tag" src={Api} alt="Api call" />
          </div>
          <button className="pro-button">
            <a
              href="https://image-search-pagination.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Demo
            </a>
          </button>
          <button className="pro-button">
            <a
              href="https://github.com/w3tsa/Vanilla-JavaScript-Projects/tree/master/Image%20Search%20with%20API%20Request"
              target="_blank"
              rel="noopener noreferrer"
            >
              Code
            </a>
          </button>
        </div>
      </section>
      <hr />
      <section className="projects">
        <a
          href="https://todowithlocal.netlify.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="proimg"
            src={project4}
            loading="lazy"
            alt="project4"
          />
        </a>
        <div className="desc">
          <p>
            This is a Todo app that utilizes local storage. Build with pure
            vanilla JavaScript, HTML, Bootstrap css. It has been deployed in
            Netlify.
          </p>
          <div>
            <img className="tag" src={Js} alt="js" />
            <img className="tag" src={Bootstrap} alt="Bootstrap" />
          </div>
          <button className="pro-button">
            <a
              href="https://todowithlocal.netlify.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              Demo
            </a>
          </button>
          <button className="pro-button">
            <a
              href="https://github.com/w3tsa/Vanilla-JavaScript-Projects/tree/master/Todo%20with%20Local%20storage"
              target="_blank"
              rel="noopener noreferrer"
            >
              Code
            </a>
          </button>
        </div>
      </section>
    </div>
  );
}

export default Projects;
